import { SessionRelevantInfo } from '@tableau/workbook-templates-widgets/lib/src/components/template_item/TemplateDescription';
import { SessionManagementService } from '../../sessionManagement/SessionManagementService';

export function buildSessionRelevantInfo(sessionManagementService: SessionManagementService): SessionRelevantInfo {
    return {
        oauthSettings: sessionManagementService.oauthSettings(),
        serverBuild: sessionManagementService.sessionServerVersion().build,
        serverVersion: sessionManagementService.sessionServerVersion().platform,
        langauge: sessionManagementService.sessionLanguage(),
    };
}